import {
  prepareCartForMarketing,
  prepareItemListForMarketing,
  prepareOrderForMarketing,
  prepareProductDetailForMarketing,
  prepareProductForMarketing,
  preparePromotionForMarketing,
} from './ga4-utils';
import { prop } from './utilities';

export interface GAObject {
  value?: number;
  item_list_id?: string;
  item_list_name?: string;
  currency?: string;
  coupon?: string;
  payment_type?: string;
  shipping_tier?: string;
  items: [
    {
      item_id: string;
      item_name: string;
      affiliation: string;
      coupon: string;
      currency: string;
      discount: number;
      index: number;
      item_brand: string;
      item_category: string;
      item_category2: string;
      item_category3: string;
      item_category4: string;
      item_category5: string;
      item_list_id: string;
      item_list_name: string;
      item_variant: string;
      location_id: string;
      price: number;
      quantity: number;
    }
  ];
}

export function ga4EventsUniversalPush(
  gObject: unknown,
  eventName: string,
  clearFirst = false,
  enhancedConversionData?: any,
  orderConsent?: any,
  gtagPush = false,
  userData: any = null,
) {
  if (typeof window !== 'undefined' && window.dataLayer && gObject) {
    if (clearFirst) {
      window.dataLayer.push({ ecommerce: null });
    }

    if (gtagPush) {
      if (enhancedConversionData) {
        (gObject as any).enhanced_conversion_data = enhancedConversionData;
      }
      if (orderConsent) {
        (gObject as any).order_consent = orderConsent;
      }
      window.gtag('event', eventName, gObject);
    } else {
      const eventData: any = {
        event: eventName,
        ecommerce: gObject,
      };

      if (userData) {
        eventData.user_data = userData;
      }
      if (enhancedConversionData) {
        eventData.enhanced_conversion_data = enhancedConversionData;
      }
      if (orderConsent) {
        eventData.order_consent = orderConsent;
      }

      window.dataLayer.push(eventData);
    }
  }
}

export function ga4EventsItem(
  affiliation: string,
  eventName: string,
  items: unknown,
  dataLayerProducts?: any,
  additionalData?: {
    item_list_id?: string;
    item_list_name?: string;
    item_variant?: string;
    location_id?: string;
    quantity?: number;
    idx?: number;
    good?: any;
  },
) {
  ga4EventsUniversalPush(
    prepareItemListForMarketing(
      affiliation,
      items,
      dataLayerProducts,
      additionalData,
    ),
    eventName,
    true,
  );
}

export function ga4EventsItemDetail(
  affiliation: string,
  eventName: string,
  item: unknown,
  dataLayerProducts?: any,
  additionalData?: {
    item_list_id?: string;
    item_list_name?: string;
    item_variant?: string;
    location_id?: string;
    quantity?: number;
    idx?: number;
    good?: any;
  },
) {
  ga4EventsUniversalPush(
    prepareProductDetailForMarketing(
      affiliation,
      item,
      dataLayerProducts,
      additionalData,
    ),
    eventName,
    true,
  );
}

export function ga4CartEvent(
  affiliation: string,
  eventName: string,
  cart: unknown,
  item?: unknown,
  dataLayerProducts?: any,
  additionalData?: {
    payment_type?: any;
    shipping_tier?: any;
    quantity?: number;
    item_list_id?: string;
    item_list_name?: string;
    idx?: number;
  },
) {
  const isItem =
    eventName === 'add_to_cart' || eventName === 'remove_from_cart';
  ga4EventsUniversalPush(
    prepareCartForMarketing(
      affiliation,
      cart,
      item,
      dataLayerProducts,
      {
        ...additionalData,
        isRemoveFromCart: eventName === 'remove_from_cart',
      },
      isItem,
    ),
    eventName,
    true,
  );
}

export function ga4EventsPurchase(
  affiliation: string,
  order: unknown,
  dataLayerProducts?: any,
  includeUserData?: boolean,
  additionalOrderData?: any,
) {
  ga4EventsUniversalPush(
    prepareOrderForMarketing(
      affiliation,
      order,
      dataLayerProducts,
      includeUserData,
      additionalOrderData,
    ),
    'purchase',
    true,
  );
}

// TODO
export function ga4EventsRefund(
  affiliation: string,
  order: unknown,
  items: unknown,
) {
  ga4EventsUniversalPush({}, 'refund', true);
}

export function ga4EventsPromotion(
  affiliation: string,
  eventName: string,
  banner: unknown,
  items?: unknown,
) {
  ga4EventsUniversalPush(
    preparePromotionForMarketing(affiliation, banner, items),
    eventName,
    true,
  );
}
